import React, {useEffect, useState} from 'react';
import t from '../../../helpers/t';
import {Biscuit, Notification} from "../../../../utils";
import moment from "moment";
import {$, _, GoogleMaps} from "../../../../../vendor";
import * as FileSaver from "../../../../../vendor/FileSaver";
import {
    errorsActions, useSelector
} from "inbooma-api";
import {getContentModifications} from "../../../../App";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import AppErrorsList from "./AppErrorsList";
import {getApiHost} from "../../../../Sync";
import {ApiRequester} from "../../../helpers/ApiRequest";
import AppErrorsSidebar from "./AppErrorsSidebar";
import Paginator from "../../../components/paginator";

const AppErrorsView = (props) => {
    let language = Biscuit.get('user.lang').replace('-','_');
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({

    });
    const [sort,setSort] = useState({
        sort: "id",
        direction: "desc"
    });
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });

    const _errors = useSelector(state => state.errors_data.getAppErrors);
    const [errorsPending, setErrorsPending] = useState(false);
    const [errors,setErrors] = useState([]);

    const _error = useSelector(state => state.errors_data.getAppError);
    const [errorPending, setErrorPending] = useState(false);
    const [error,setError] = useState([]);

    const [resetFilter,setResetFilter] = useState(false);


    useEffect(() => {
        if (errorPending === false || _error.success === "") {
            return;
        }
        if (_error.success === true) {
            setError(_error.data);
            //setIndex(_resource.data.id);
           } else {
            console.log("Failed fetching error!");
        }
        setErrorPending(false);

        if(!errorsPending){
            setInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_error]);

    useEffect(() => {
        if (errorsPending === false || _errors.success === "") {
            return;
        }

        if (_errors.success === true) {
            setErrors(_errors.data);
            setPagination({..._errors.pagination});

        } else {
            console.log("Failed fetching errors!");
        }
        setErrorsPending(false);
        if(!errorPending){
            setInitialized(true);
        }
        $(window).scrollTop(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_errors]);

    const loadNextPage = (page) => {

        //if (!pagination.has_next_page) return;

        setErrorsPending(true);

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;
        // fetch next page
        props.dispatch(errorsActions.getAppErrors({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const filterChangedHandle = (filter,sorts = null) => {
        let requestFilter = {...filter};
        if(sorts === null){
            sorts = sort;
        } else {
            setSort(sorts);
        }
        requestFilter.sort = sorts.sort;
        requestFilter.direction = sorts.direction;
        if(typeof filter.limit !== 'undefined'){
            requestFilter.limit = filter.limit;
            if(typeof requestFilter.page !== 'undefined'){
                delete requestFilter.page;
            }
        } else {
            requestFilter.limit = paginationLimit;
            requestFilter.page = 1;
        }

        props.dispatch(errorsActions.getAppErrors({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setErrorsPending(true);
        setFilter(filter);
    };

    const submenuItems = [
        {
            name: t('API',null,'capital'),
            link: 'errors',
            data_inb_val: t('API',null,'capital'),
            icon: 'fi fi-list-thumbnails',
            isActive: false,
            isAccessible: Biscuit.get('user.is_superuser') === 'true'
        },{
            name: t('APP',null,'capital'),
            link: 'apperrors',
            data_inb_val: t('APP',null,'capital'),
            icon: 'fi fi-list',
            isActive: true,
            isAccessible: Biscuit.get('user.is_superuser') === 'true'
        }
    ];

    const onSortChangedHandle = (ev) => {

        const el = ev.currentTarget;
        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }
            props.dispatch(errorsActions.getAppErrors({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setErrorsPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key,value){
                key.classList.remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));

        }
    };

    const initialize = () => {

        if (initialized || errorsPending  || errorPending) return;
        let requestFilter = {...filter};
        requestFilter = {...requestFilter,page: 1};
        requestFilter = {...requestFilter,limit: paginationLimit};
        requestFilter = {...requestFilter,sort: sort.sort};
        requestFilter = {...requestFilter,direction: sort.direction};
        if(props.params !== null && typeof props.params[1] !== 'undefined' && props.params[0] === "id"){
            requestFilter ={...requestFilter,id:props.params[1]};
        }
        props.dispatch(errorsActions.getAppErrors({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setErrorsPending(true);
        if(props.params !== null && !(location.pathname.indexOf('errors/add') >= 0) && typeof props.params[0] !== 'undefined' && props.params[0] !== 'add' && props.params[0] !== "id"){
            props.dispatch(errorsActions.getAppError({
                token: Biscuit.get('token'),
                id: props.params[0],
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setErrorPending(true);
        }
    };

    if(!initialized) initialize();

    const _exchangeLabel = (value) => {

        let cm = getContentModifications();
        if (cm.labels != null) {
            if (cm.labels[value] !== undefined) {
                return cm.labels[value];
            }
        }
        return value;
    };

    const showNotification = (msgType, itemId, apiMsg) => {
        // little delay necessary to make notifications visible (render of background must be done before)
        setTimeout( () => {
            if (msgType === 'success') {
                new Notification({
                    message : t('saved_${a}',{a:t('resource')},'capital')+' #'+ itemId,
                    duration : 5000,
                    type : 'success',
                    closeable : true,
                    icon : 'fi fi-check'
                });
            } else if (msgType === 'warning') {
                new Notification({
                    message : (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg,null,'capital') : t('request_error',null,'capital'),
                    duration : 5000,
                    type : 'warning',
                    closeable : true,
                    icon : 'fi fi-x'
                });
            }

        },200);

    };


    let tabs =[{
        name: t('id'),
        mediumWidth: 1,
        smallWidth: 1,
        title: t('sort_by_${a}',{a:t('id')}),
        canSort: true,
        extraClasses:"inb-order-big",
        sort: {
            direction: 'desc',
            data_inb_val: 'id'
        }
    }, {
        name: t('reservation_id',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        title: t('sort_by_${a}',{a:t('reservation_id')}),
        canSort: true,
        extraClasses:"inb-order-big",
        sort: {
            direction: null,
            data_inb_val: 'reservation_id'
        }
    },{
        name: t('order_id',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        extraClasses:"inb-order-big",
        title: t('sort_by_${a}',{a:t('order_id')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'order_id'
        }
    },{
        name: t('Client ID',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        extraClasses:"inb-order-big",
        title: t('sort_by_${a}',{a:t('Client ID')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'client_id'
        }
    }, {
        name: t('User ID',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        extraClasses:"inb-order-big",
        title: t('sort_by_${a}',{a:t('User ID')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'user_id'
        }
    },{
        name: t("type"),
        mediumWidth: 1,
        smallWidth: 1,
        extraClasses:"inb-order-big",
        title: t('type',null,'capital'),
        canSort: false
    }, {
        name: t('app_screen_title',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        title: t('app_screen_title'),
        canSort: false
    }, {
        name: t('call_function',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        title: t('call_function'),
        canSort: false
    },{
        name: t('error_text',null,'capital'),
        mediumWidth: 1,
        smallWidth: 2,
        title: t('error_text'),
        canSort: false
    }, {
        name: t('additional_info',null,'capital'),
        mediumWidth: 1,
        smallWidth: 2,
        title: t('additional_info'),
        canSort: false
    }, {
        name: t('created',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        title: t('sort_by_${a}',{a:t('created')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'created'
        }
    }];

    return (
        <>
            {(initialized) && <AppErrorsSidebar
                dispatch={props.dispatch}
                heading={t("Errors (APP)")}
                filterChangedHandle={filterChangedHandle}
                filter={filter}
                setFilter={setFilter}
                resetFilter={resetFilter}
                setResetFilter={setResetFilter}
                sort={sort}
            />}
            <div id='inb-c-main' className='columns'>
                <InboomaSubmenu
                    tabs={submenuItems}
                    smallOnlyTitle={t('errors',null,'capital')}
                    pagination={pagination}
                    extraClasses={"sticky-top"}
                />

                <SortNav
                    tabs={tabs}
                    extraId={"app-error-nav"}
                    listStyle="tight"
                    extraClasses={"sticky-top-sortbar"}
                    handler={onSortChangedHandle}/>
                {/* {initialized && errors.length > 0 && !errorsPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />} */}
                {(initialized && errors.length > 0 && !errorsPending) &&
                <AppErrorsList
                    errors={errors}
                    dispatch={props.dispatch}
                    _exchangeLabel={_exchangeLabel}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    key={"inb-c-main-resources"}
                    sort={sort}
                    setSort={setSort}
                    setInitialized={setInitialized}
                />}
                {(initialized && (errors.length < 1 || typeof errors.length === 'undefined') && !errorsPending) &&
                <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement">
                        <div className="inb-image-box">
                            <img src="assets/img/no_data.svg"/>
                        </div>
                        <h3>
                            { t('app_msg_collection_empty') }
                        </h3>
                        <p>
                            { t('app_msg_collection_empty_body') }
                        </p>
                    </div>
                </>
                }
                {/* {initialized && errors.length > 0 && !errorsPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />} */}
                {(errorsPending) && <> <div
                    id="inb-app-collection-empty"
                    className="inb-announcement">
                    <div className="inb-image-box">
                        <img className="rollingLoader" src="assets/img/rolling_loader.svg"/>
                    </div>
                </div></>}

               {/* {((props.params !== null && props.params[0] !== 'id' && Biscuit.get('user.role') === 'admin' && initialized && !errorPending)) &&
                <ItemView
                    onClose={onCloseResource}
                    dispatch={props.dispatch}
                    locations={locations}
                    contingents={contingents}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    showNotification={showNotification}
                    requestPath={props.returnPath}
                    resource={index !== null?resources[index]:resource}
                    setIndex={setIndex}
                    setAdd={setAdd}
                    setResource={setResource}
                    setResourcesPending={setResourcesPending}
                />
                }
                {((props.params !== null && props.params[0] !== 'id' && Biscuit.get('user.role') !== 'admin' && initialized && !resourcePending) || index !== null || add !== false)  &&
                <ItemViewService
                    onClose={onCloseResource}
                    dispatch={props.dispatch}
                    locations={locations}
                    contingents={contingents}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    showNotification={showNotification}
                    requestPath={props.returnPath}
                    resource={index !== null?resources[index]:resource}
                    setIndex={setIndex}
                    setAdd={setAdd}
                    setResource={setResource}
                    setResourcesPending={setResourcesPending}
                />
                }*/}
            </div>
        </>
    );
}

export default AppErrorsView;